import React from 'react';
import { Select, Form } from 'antd';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { Props } from './props';
import mask from '../../utils/mask';

export const SelectInscricao: React.FC<Props> = ({ setProps, disabled, description, cliente }) => {
  const inscricaoAtiva = useSelector(
    (state: ApplicationState) => state.auth.user?.inscricoesEstaduais
  );

  const { Option } = Select;
  const handleSelect = (value: any, e: any) => {
    setProps(value);

  };

  return (
    <Form.Item
      data-cy="selecionarTomador"
      name={description ? description : 'tomador'}
      rules={[{ required: true, message: `Digite o ${description ? description : 'tomador'}` }]}
    >
      <Select
        onChange={handleSelect}
        showSearch
        disabled={disabled}
        defaultValue={cliente}
        filterOption={(inputValue, element) =>
          element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
        }
        placeholder={`Selecione ${description ? description : 'o tomador'}`}
        style={{ width: '100%', textAlign: 'center' }}
      >
        {inscricaoAtiva?.map((item) => (
          <Option key={item.codParceiro} value={/*mask('camelCase', item.nomeParceiro) + */ item.codParceiro}>
            {mask('camelCase', item.nomeParceiro)} <br />
            {mask('cpfCnpj', item.cnpjcpf)} <br />
            {item.inscricaoEstadual} <br />
            {item.codParceiro}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

